<template>
  <div class="hr">
    <div class="header">
      <p>Melde dich gerne für weitere Infos bei:</p>
    </div>
    <div class="people">
      <div class="person">
        <div class>
          <p>Heike Ahlmer</p>
          <p>Head of HR</p>
        </div>
        <img src="../../images/heike_pixelart2.png" />
        <p>ahlmer@gonicus.de</p>
      </div>
      <div class="person">
        <p>Roxanna Paetzold Varela</p>
        <p>HR Managerin</p>
        <img src="../../images/roxanna_pixelart2.png" />
        <p>roxanna.paetzold-varela@gonicus.de</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ResultHRM",
  props: {
    msg: String,
  },
};
</script>

<style scoped>
.header {
  grid-area: header;
  text-align: left;
}

p {
  color: #0f0f;
  margin: 0.3em 0;
}

img {
  width: 100%;
  max-width: 120px;
  height: auto;
  display: block;
  margin-bottom: 0.5em;
}

.people {
  grid-area: content;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;
}

.person {
  text-align: left;
}

.hr {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-areas:
    "header header"
    "content content";
  gap: 12px;
  padding: 10px;
}

@media (max-width: 600px) {
  .people {
    grid-template-columns: 1fr;
  }

  .hr {
    grid-template-columns: 1fr;
    grid-template-areas:
      "header"
      "content";
  }

  img {
    max-width: 80px;
    margin: 0 auto 0.5em auto;
  }

  .person {
    text-align: center;
  }
}
</style>